import type { StoreConfig } from "@/dropai/types";

export const store = {
  name: "Llavero antiestres",
  product: {
    name: "Desesteclate",
    price: 19.99,
    currency: "EUR",
    variants: [],
  },
} satisfies StoreConfig;
